import { getApiLocation } from "./getApiLocation";

export function locationController() {
  return { getApiLocation };
}
